export default __webpack_public_path__ + "static/media/new5.8bba32df.png";